// extracted by mini-css-extract-plugin
export var button = "w_L";
export var buttonContent = "w_bK";
export var buttonInner = "w_S";
export var loading = "w_bM";
export var loadingContainer = "w_bL";
export var loadingSpinner = "w_b";
export var loadingText = "w_d";
export var spin = "w_c";